import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendEmail } from "../../api";
import { Layout } from "../../layout";
import Button from "@kaizen-ui/button";
import "./styles.css";
import AccessibilityContext from "../../components/auth/UserPermissionContext";
import WithAuth from "../../components/auth/WithAuth";
import WithAdminUIAuth from "../../components/auth/WithAdminUIAuth";

const SendEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const permissions = useContext(AccessibilityContext).find(x => x.pagename === "user");

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  if (!permissions) return null;  // waiting for context to load

  if (permissions.read === false) {
    navigate("/unauthorized");
    return null;
  }

  const handleSendEmail = async () => {
    const trimmedEmail = email.trim();
    setStatusMessage('');

    if (!validateEmail(trimmedEmail)) {
      setStatusMessage('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    const payload = { Email: trimmedEmail };

    try {
      await sendEmail(payload);
      setStatusMessage('Email sent successfully!');
    } catch (error) {
      if(error.status_code==500)
      {
        setStatusMessage('Failed to send email.');
      }
      else{
        setStatusMessage('No user found with given email id.');
      }
      
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Layout key="layuser" title="Send Email To User">
      <div>
        <table className="search-table">
          <tbody>
            <tr>
              <td>
                <input
                  type="text"
                  style={{ height: "35px", width: "300px" }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </td>
              <td style={{ verticalAlign: "top", paddingLeft: "20px" }}>
                <Button
                  css={{ color: "black" }}
                  size="standard"
                  tone="secondary"
                  onClick={handleSendEmail}
                  disabled={isLoading || !validateEmail(email.trim())}
                  className="dashboard-header-primary dashboard-header-frame-1"
                >
                  {isLoading ? 'Sending...' : 'Send'}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>

        {statusMessage && (
          <p style={{ marginTop: '10px', color: statusMessage.startsWith('Email sent') ? 'green' : 'red' }}>
            {statusMessage}
          </p>
        )}
      </div>
    </Layout>
  );
};


export default WithAuth(WithAdminUIAuth(SendEmail));
